import { useState, useRef } from "react"

const useCaptchaValidation = () => {
  const captchaRef = useRef(null)
  const [captchaError, setCaptchaError] = useState(false)

  const validateCaptcha = () => {
    if (!captchaRef.current.getValue()) {
      setCaptchaError(true)
      return false
    }
    return true
  }

  const resetCaptchaError = () => {
    setCaptchaError(false)
  }
  const resetCaptcha = () => {
    if (captchaRef.current) {
      captchaRef.current.reset()
    }
  }

  const showCaptchaError = () => {
    setCaptchaError(true)
  }

  return {
    captchaRef,
    captchaError,
    validateCaptcha,
    resetCaptchaError,
    showCaptchaError,
    resetCaptcha
  }
}

export default useCaptchaValidation
